import { NavItemProps } from 'business/models/CustomModels';
import React from 'react';
import { NavLink, useLocation, useResolvedPath } from 'react-router-dom';
import './SideBar.scss';
const dropRoutes = ['drop', 'compare', 'well'];
const routesWithChildren = ['imaging'];
const NavItem = ({
  onClick,
  style,
  icon,
  label,
  to,
  isDisabled,
  activeClass,
  matchTopLevelSegment,
}: NavItemProps) => {
  const location = useLocation();
  const resolvedPath = useResolvedPath(to);
  function click(e) {
    if (isDisabled) {
      e.preventDefault();
    } else if (onClick) {
      onClick();
    }
  }
  const handleIsActive = () => {
    const locationValue = location.pathname.split('/');
    const lastLocationValue = locationValue.pop();
    const toValue = to.split('/');
    const lastToValue = toValue[toValue.length - 1];
    const firstToValue = toValue[1];
    if (label == 'Help') {
      return false;
    }
    // Handle child routes (like in the case of the Imaging tabs)
    if (
      routesWithChildren.some((subpathRoute) => locationValue.includes(subpathRoute)) &&
      locationValue.includes(lastToValue)
    ) {
      return true;
    }
    if (
      dropRoutes.includes(lastLocationValue) &&
      dropRoutes.includes(lastToValue) &&
      lastLocationValue === lastToValue
    ) {
      return true;
    }

    if (!resolvedPath) {
      return false;
    }
    if (
      location.pathname === resolvedPath.pathname ||
      (matchTopLevelSegment && location.pathname.split('/')[1] === firstToValue)
    ) {
      return true;
    }
    return false;
  };
  function getClassNameBasedOnDisable() {
    if (isDisabled) {
      return 'sidebar-item  expand-sidebar-item-active cursor-mouse';
    }
    return 'sidebar-item';
  }
  return (
    <NavLink
      id={`navitem-navlink-${label.toLowerCase()}-wrapper`}
      style={{
        color: 'white',
        height: '10.65%',
        ...style,
      }}
      onClick={click}
      to={to}
      className={
        handleIsActive() ? `${activeClass} sidebar-item-active  bg-selected-dark` : ''
      }
    >
      <div
        id={`navitem-navlink-disable-${label.toLowerCase()}-wrapper`}
        className={getClassNameBasedOnDisable()}
      >
        <div
          id={`navitem-navlink-sidebar-icon-${
            icon?.type?.name || label?.toLowerCase().replace(/\s+/g, '-')
          }`}
          className="sidebar-item-icon"
        >
          {icon}
        </div>
        <div
          id={`navitem-navlink-sidebar-${label.toLowerCase()}`}
          className="sidebar-item-text"
        >
          {label}{' '}
        </div>
      </div>
    </NavLink>
  );
};

export default NavItem;
